import React, { useState, useContext, useEffect } from 'react';
import { useRouter } from 'next/router';
import { Button, MenuItem, Menu } from '@material-ui/core';
import LanguageRoundedIcon from '@material-ui/icons/LanguageRounded';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';

import useStyles from './styles';
import useTranslation from 'hooks/useTranslation';
import Cookies from 'js-cookie';

const SelectLanguageMenu: React.FC = () => {
  const { locale } = useRouter();
  const { t } = useTranslation();
  const router = useRouter();
  const classes = useStyles();
  const languagesOption = ['pt', 'en', 'es'];
  /* eslint-disable-next-line */
  const [selectedIndexMenu, setSelectedIndexMenu] = useState(1);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClickMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  useEffect(() => {
    Cookies.set('instasorteioLanguage', String(router.locale));
  }, [router.locale]);

  const handleMenuItemClick = (
    event: React.MouseEvent<HTMLElement>,
    index: number,
    option: string,
  ) => {
    let lang: 'pt' | 'en' | 'es' = 'pt';
    if (option === 'en') {
      lang = 'en';
    }
    if (option === 'pt') {
      lang = 'pt';
    }
    if (option === 'es') {
      lang = 'es';
    }
    // alterLanguage(lang);
    router.push(router.pathname, router.pathname, { locale: lang });
    setSelectedIndexMenu(index);
    setAnchorEl(null);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  return (
    <div className={classes.box}>
      <Button
        onClick={handleClickMenu}
        startIcon={<LanguageRoundedIcon />}
        endIcon={anchorEl ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        style={{ width: 180 }}
      >
        {router.locale === 'pt' && 'Português'}
        {router.locale === 'en' && 'English'}
        {router.locale === 'es' && 'Espanhol'}
      </Button>

      <Menu
        onClose={handleCloseMenu}
        anchorEl={anchorEl}
        // keepMounted
        open={Boolean(anchorEl)}
      >
        {languagesOption.map((option, index) => (
          <MenuItem
            key={option}
            selected={locale === option}
            onClick={event => handleMenuItemClick(event, index, option)}
            className={classes.menuItem}
          >
            {option === 'pt' && 'Português'}
            {option === 'en' && 'English'}
            {option === 'es' && 'Espanhol'}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default SelectLanguageMenu;
